import { action as apiAction } from 'api/Api'
import {
  addCardRelation
} from 'store/redux/cardRelations'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  predecessorId: number
  successorId: number
}

export default (payload: Payload) => async dispatch => {
  const { predecessorId, successorId } = payload

  const optimisticAction = optimisticDispatch(dispatch, [
    addCardRelation({
      id: predecessorId,
      successorIds: [successorId]
    }),
    addCardRelation({
      id: successorId,
      predecessorIds: [predecessorId]
    })
  ])

  try {
    await apiAction('AddCardSuccessor', {
      succCardId: successorId,
      predCardId: predecessorId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()
    
    if (
      error.code !== 1104 && // TheOppositeRelationAlreadyExists
      error.code !== 1103 && // CardRelationCannotPointAtItselfException
      error.code !== 1100 // CardRelationExistsException
    ) { // Exists
      throw error
    }
  }
}
